import React, { useState } from 'react'

export default function VideoItem({ video, img, text }) {
    const [isLoaded, setIsLoaded] = useState(false);
    return (
        <>
            <div className="video-quiz__img" style={{ aspectRatio: "65/116", marginBottom: 8 }}>
        
                    <img
                        src={process.env.PUBLIC_URL + `/video/video-avatars/${img}`}

                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            zIndex: 1,
                            filter: 'blur(3px)',
                            opacity: !isLoaded ? 1 : 0,
                        }}
                    />
                
                {video && <video
                    // src={process.env.PUBLIC_URL + `/video/video-avatars/${video}`}
                    style={{ width: '100%', borderRadius: '12rem' }}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onLoadedData={() => setIsLoaded(true)}
                >
                    <source src={video} type="video/mp4" />

                </video>
                }


                <span>{text}</span>
            </div>


        </>
    )
}
